export default __webpack_public_path__ + "static/media/down.9c11a264.png";